// @Styles
require('./referralsInvitationsFilter.scss');
// @Vendors
const React = require('react');
const PropTypes = require('prop-types');
// @commons
const ReferralsInvitationsGiftFilter = require('./referralsInvitationsGiftFilter');
const ReferralsInvitationsStateFilter = require('./referralsInvitationsStateFilter');
const DateFilter = require('components/commons/dateFilter/dateFilter');
const OKModal = require('components/commons/OKModal/OKModal');
//@constants
const { DATE_FILTER_NONE } = require('constants/index');

class ReferralsInvitationsFilter extends React.Component {

    constructor(props) {
        super(props);

        const { immFilter } = props;

        this.state = {
            dateSelected: immFilter.getIn(['date','selected']),
            dateFrom: immFilter.getIn(['date','from']),
            dateTo: immFilter.getIn(['date','to']),
            giftSelected: immFilter.getIn(['gift','selected']),
            stateSelected: immFilter.getIn(['state', 'selected'])
        };

        this.handleFormSubmit = this.handleFormSubmit.bind(this);
        this.handleChangeDateMin = this.handleChangeDateMin.bind(this);
        this.handleChangeDateMax = this.handleChangeDateMax.bind(this);
        this.handleChangeDateSelected = this.handleChangeDateSelected.bind(this);
        this.handleChangeStateSelected = this.handleChangeStateSelected.bind(this);
        this.handleChangeGiftSelected = this.handleChangeGiftSelected.bind(this);
    }

    handleChangeDateMax(dateTo) {
        this.setState({
            dateTo
        });
    }

    handleChangeDateMin(dateFrom) {
        this.setState({
            dateFrom
        });
    }

    handleChangeDateSelected(dateSelected) {
        this.setState({
            dateSelected
        });
    }

    handleChangeStateSelected(stateSelected) {
        this.setState({
            stateSelected
        });
    }

    handleChangeGiftSelected(giftSelected) {
        this.setState({
            giftSelected
        });
    }

    handleFormSubmit(event) {
        event.preventDefault();
        const { onCloseClick, setFilters } = this.props;
        const { dateFrom, dateTo, dateSelected, giftSelected, stateSelected } = this.state;
        setFilters({
            date: {
                isActive: dateSelected !== DATE_FILTER_NONE,
                selected: dateSelected,
                from: dateFrom,
                to: dateTo
            },
            state: {
                isActive: !!stateSelected,
                selected: stateSelected
            },
            gift: {
                isActive: !!giftSelected,
                selected: giftSelected
            }
        });
        onCloseClick();
    }

    render() {
        const { immFilter, immGiftTypes, isOpen, onCloseClick } = this.props;

        const content = (
            <section className="referrals-invitations-filter">
                <DateFilter
                    immFilter={immFilter.get('date')}
                    onChangeMin={this.handleChangeDateMin}
                    onChangeMax={this.handleChangeDateMax}
                    onChangeSelected={this.handleChangeDateSelected}
                />
                <ReferralsInvitationsStateFilter
                    immFilter={immFilter.get('state')}
                    onChangeSelected={this.handleChangeStateSelected}
                />
                <ReferralsInvitationsGiftFilter
                    immFilter={immFilter.get('gift')}
                    immGiftTypes={immGiftTypes}
                    onChangeSelected={this.handleChangeGiftSelected}
                />
            </section>
        );

        return (
            <OKModal
                content={content}
                footerType="navigation"
                isOpen={isOpen}
                onCloseCallback={onCloseClick}
                onPrimaryButtonClick={this.handleFormSubmit}
                onSecondaryButtonClick={onCloseClick}
                primaryButtonText="filterDate-apply"
                secondaryButtonText="filterDate-cancel"
                title="referrals-filtersTitle"
            />
        );
    }
}

ReferralsInvitationsFilter.propTypes = {
    immFilter: PropTypes.object.isRequired,
    immGiftTypes: PropTypes.object.isRequired,
    isOpen: PropTypes.bool.isRequired,
    onCloseClick: PropTypes.func.isRequired,
    setFilters: PropTypes.func
};

export default ReferralsInvitationsFilter;
